<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 mt-2 py-0">
					<div class="d-flex align-items-center">
						<div class="d-flex align-items-center">
							<h5 style="font-size: 14px;" class="m-0 p-0 text-white bg-primary d-inline shadow-sm border border-primary rounded px-2 py-1">
								Hardware Setup
							</h5>
					
					</div>
					</div>
					<div v-if="['master_admin', 'admin', 'finance'].includes(role)">
						<button 
							class="float-right btn btn-primary shadow" 
							v-on:click="formHardwareSetupActive=!formHardwareSetupActive">
							{{ dicts.add_form[dicts.lang] }}
						</button>
					</div>
					
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formHardwareSetupActive">
						<div class="row p-3 mx-2 bg-white shadow">
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.no_sn[dicts.lang] }}</label>
								
								<smart-search 
									init
									url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
									:addon="{item: 'Antena,Transmiter'}"
									key-tag="serial_number"
									v-on:clear="(res)=>{clearHQCData()}"
									v-on:update="(data)=>smartSearchAddSerialNumber(data)"
									:search-value="newsetupsnlabel"
									@update-direct="(label)=>newsetupsnlabel=label">
								</smart-search>



							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">SPKP ID / IMO</label>
								<input type="number" class="form-control w-100 rounded"
								       v-model="newHardwareSetup.id_transmitter"/>
							</div>

							<!-- NOMER JB -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.no_jb[dicts.lang] }}</label>
								<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
								              :addon="{item:'jb,Junction box'}"
								              key-tag="serial_number" v-on:update="(data)=>smartSearchAddNoJb(data)"
								              :search-value="newsetupjblabel"
								              @update-direct="(label)=>newsetupjblabel=label">
											</smart-search>
							</div>

							<!-- Nama kapal -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.vessel[dicts.lang] }}</label>
								<b-button class="btn btn-light mr-2 form-control w-100 rounded d-flex align-items-start"
								          v-b-modal.modal-create-vessel v-model="newHardwareSetup.vessel_id">
									{{ selectedVesselName }}
								</b-button>
							</div>

							<!-- NBK -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">NBK</label>
								<input type="text"  class="form-control w-100 rounded" v-model="newHardwareSetup.nbk" />
							</div>

							<!-- STATUS -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">STATUS</label>
								<smart-select name="status" :options="statusTypeOptions"
								              v-on:update="updateNewHsStatus">
								</smart-select>
							</div>
							<!-- INTERVAL STATUS -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">STATUS INTERVAL</label>
								<smart-select 
									name="interval_status" 
									:options="statusInterval"
									v-on:update="updateNewIntervalStatus">
								</smart-select>
							</div>

							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.packet[dicts.lang] }}</label>
								<smart-select name="packet" :options="packetTypeOptions"
								              v-on:update="updateNewHsPacket"></smart-select>
							</div>

							<!-- PACKET INSTALL -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">APPLICATION  INSTALL</label>
									<smart-search init url="/api/master/seeker/applications" key-tag="application_name"
								              v-on:update="(data)=>smartSearchAddApplication(data)"
								              :search-value="newsetupapplabel"
								              @update-direct="(label)=>newsetupapplabel=label">
									</smart-search>
							</div>
							
							<!-- DEVICE STATUS -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">DEVICE STATUS</label>
							<select class="form-control" v-model="form.device_status_id">
								<option value="" disabled>Pilih Device Status</option>
								<option
								v-for="status in deviceStatuses"
								:key="status.id"
								:value="status.id"
								>
								{{ status.status_code }}
								</option>
							</select>
							</div>

							<!-- STATUS REPORT (input readonly) -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">STATUS REPORT</label>
							<input type="text"
									class="form-control"
									:value="form.forward"
									readonly>
							</div>
							<!-- TANGGAL SETUP -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.test_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-test-date" v-model="newHardwareSetup.date_test" class="mb-2">
									{{ newHardwareSetup.date_test }}
								</b-form-datepicker>
							</div>
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.skat_date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-skat" v-model="newHardwareSetup.date_skat" class="mb-2">
									{{ newHardwareSetup.date_skat }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.notes[dicts.lang] }}</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newHardwareSetup.notes"/>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="newHardwareSetupSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Hardware Setup Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="errorNewHardwareSetup">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Hardware Setup Baru.</p>
										</div>
										<div v-for="err in errorHardwareSetupList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewHardwareSetup">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewHardwareSetup">
									{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>


				<!-- MODAL ADD VESSEL -->
				<b-modal id="modal-create-vessel" title="Add Vessel" hide-footer @show="resetModal" @hidden="resetModal"
				         @ok="handleOk" size="lg" scrollable>

					<ul class="nav nav-tabs">
						<li class="nav-item">
							<button class="nav-link" :class="[selectedTab==0?'active':'']" href="#"
							        v-on:click="selectedTab=0;newHardwareSetup.vesselExisting='existing'">
								{{ dicts.new_vessel[dicts.lang] }}
							</button>
						</li>
						<li class="nav-item">
							<button class="nav-link" :class="[selectedTab==1?'active':'']" href="#"
							        v-on:click="selectedTab=1;newHardwareSetup.vesselExisting='new'">
								{{ dicts.list_vessel[dicts.lang] }}
							</button>
						</li>
					</ul>
					<div class="tab-content" id="myTabContent">
						<div v-if="selectedTab==0">
							<create-vessel @createvessel="createVesselResult" :formstate="true" noshadow/>
						</div>
						<div v-if="selectedTab==1">
							<div class="row w-100" style="height:500px">
								<div class="col-12 my-2 py-0">
									<div class="row p-3 mx-2 bg-white">
										<div class="col-12 mt-2">
											<label class="">{{ dicts.list_vessel[dicts.lang] }}</label>
											<smart-search init url="/api/master/seeker/vessel" key-tag="name"
											              v-on:update="(data)=>smartSearchUpdatedVessel(data,idx-1)"
											              :search-value="listvessellabel"
											              @update-direct="(label)=>listvessellabel=label"></smart-search>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-modal>
				<div class="col-12 my-2 py-0">

					<!-- SEARCH -->
					<div class="search-container">
						<input 
							type="text"
							class="search-input"
							placeholder="search"
							v-model="searchTerm"
							@input="doSearch"
						/>
					</div>

					<!-- MOBILE SCROLL -->
					<div class="mobile-scroll-wrapper">

						<div class="mobile-scroll-content">

							<datatable 
								:currentIdx="currentPage" 
								:lang="dicts.lang" 
								:datas="filteredHardwareSetups"
								:structure="hardwaresetupTableStructure" 
								:next-url="nextUrl"
								:prev-url="prevUrl"
								:init="loadData" 
								:show-search="false"
								:hide-pagination="true"
								use-filter
								use-seeker
								seeker-url="/api/inventaris/seeker/hardware-setup"
								@change-page="(isNext)=>{changePage(isNext)}"
								@refetch="(row)=>{rowLimit=row;getHardwareSetups()}"
								@change-url="(url)=>getHardwareSetups(url+(url.includes('?')?'&':'?')+'limit='+rowLimit)"
							>

								<template #customcell={obj,index}>

									<!-- ================= MOBILE ================= -->
									<td v-if="isMobile" colspan="100" class="py-3">
										<ul 
											style="list-style:none;width:100%;padding:0"
											class="rounded shadow bg-white p-2"
										>

											<!-- SERIAL -->
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small>
														{{ dicts.no_sn[dicts.lang] }}:
													</small>
													<br>
													<b style="font-size:10pt">
														{{ obj.serial_number
															? obj.serial_number.serial_number
															: "-" }}
													</b>
												</div>
											</li>

											<!-- ID TRANSMITTER -->
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small>ID transmitter:</small>
													<br>
													<b style="font-size:10pt">

														{{ obj.id_transmitter || "-" }}
													</b>
												</div>
											</li>
											<!-- VESSEL -->
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small>
														{{ dicts.vessel[dicts.lang] }}:
													</small>
													<br>
													<b style="font-size:10pt">
														{{ obj.vessel
															? obj.vessel.name
															: "-" }}
													</b>
												</div>
											</li>

											<!-- STATUS -->
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small>Status:</small>
												<br>
													<b style="font-size:10pt">
														{{ obj.device_status
															? obj.device_status.status_code
															: "-" }}
													</b>
												</div>
											</li>

											<!-- START OF AIRTIME -->
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small>START OF AIRTIME:</small>
													<br>
													<b style="font-size:10pt">
														{{ obj.airtime_period &&
															obj.airtime_period.start_period
															? formatTanggal(obj.airtime_period.start_period)
															: '-' }}

													</b>
												</div>
											</li>

											<!-- END OF AIRTIME -->
											<li class="mt-2">
												<div class="text-left mx-3 pt-0">
													<small>END OF AIRTIME:</small>
													<br>
													<b style="font-size:10pt">
														{{ obj.airtime_period &&
															obj.airtime_period.end_periode
															? formatTanggal(obj.airtime_period.end_periode)
															: '-' }}

													</b>
												</div>
											</li>

											<!-- ACTION -->
											<li class="mt-3">
												<div class="text-left mx-3 pt-0">
													<b-button
														v-b-modal.modal-detail-hardware
														class="btn btn-primary mr-2 mb-1"
														v-on:click="selectedDetail=index"
													>
														<b-icon icon="eye"></b-icon>
													</b-button>
													<b-button
														v-b-modal.modal-edit-hardware
														class="btn btn-info mr-2 mb-1"
														v-on:click="selectedIdforEdit=index"
													>
														<b-icon icon="pencil-square"></b-icon>
													</b-button>
												</div>
											</li>
										</ul>
									</td>

									<!-- ================= DESKTOP ================= -->

									<td v-if="!isMobile">
										{{ ((currentPage - 1) * perPage) + index + 1 }}
									</td>

									<td v-if="!isMobile">
										{{ obj.serial_number ? obj.serial_number.serial_number : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.id_transmitter || "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.jb ? obj.jb.serial_number : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.nbk || "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.vessel ? obj.vessel.name : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.vessel ? obj.vessel.client.first_name : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.application ? obj.application.application_name : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.device_status ? obj.device_status.status_code : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.forward || "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.vessel ? obj.vessel.gt : "-" }}
									</td>

									<td v-if="!isMobile">
										{{ obj.status }}
									</td>

									<td v-if="!isMobile">
										{{ obj.date_test | timeformat }}
									</td>

									<td v-if="!isMobile">
										{{ obj.airtime_period && obj.airtime_period.start_period
											? formatTanggal(obj.airtime_period.start_period)
											: '-' }}
									</td>

									<td v-if="!isMobile">
										{{ obj.airtime_period && obj.airtime_period.end_periode
											? formatTanggal(obj.airtime_period.end_periode)
											: '-' }}
									</td>

									<!-- ACTION -->
									 <td v-if="!isMobile">
									<b-dropdown id="dropdown-actions" variant="primary" text="Actions" class="mb-1" dropleft>
										<b-dropdown-item @click="selectedDetail = index" v-b-modal.modal-detail-hardware>
										<b-icon icon="eye" class="mr-2"></b-icon> View
										</b-dropdown-item>
										<b-dropdown-item 
										v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'"
										@click="selectedHistories = index" v-b-modal.modal-detail-histories-hardware>
										<b-icon icon="clock-history" class="mr-2"></b-icon> History
										</b-dropdown-item>
										<b-dropdown-item 
										v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'"
										@click="selectedIdforEditStatus = index" v-b-modal.modal-edit-status-hardware>
										<b-icon icon="arrow-counterclockwise" class="mr-2"></b-icon>Hadware Status
										</b-dropdown-item>
										<b-dropdown-item 
										@click="selectedIdforEdit = index" v-b-modal.modal-edit-hardware>
										<b-icon icon="pencil-square" class="mr-2"></b-icon> Edit
										</b-dropdown-item>
										<b-dropdown-item 
										v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'"
										@click="deleteId = obj.id; itemToDelete = obj" v-b-modal.modal-delete variant="danger">
										<b-icon icon="trash" class="mr-2"></b-icon> Delete
										</b-dropdown-item>
									</b-dropdown>
									</td>
								</template>
							</datatable>
						</div>
					</div>

					<!-- PAGINATION -->
					<div class="d-flex justify-content-between align-items-center mt-2 pagination-mobile">

						<!-- INFO -->
						<div class="text-muted">

							Showing {{ (currentPage - 1) * perPage + 1 }}
							to {{ ((currentPage - 1) * perPage) + filteredHardwareSetups.length }}
							of {{ totalItems }} entries

						</div>

						<!-- BUTTON -->
						<div>

							<b-button 
								class="mr-2"
								variant="outline-primary"
								:disabled="!prevUrl"
								@click="changePage(false)"
							>
								Prev
							</b-button>

							<b-button 
								variant="outline-primary"
								:disabled="!nextUrl"
								@click="changePage(true)"
							>
								Next
							</b-button>

						</div>

					</div>

				</div>
				<!-- EDIT-->
				<b-modal id="modal-edit-hardware" title="EDIT" scrollable no-close-on-backdrop size="lg">
					<div class="row" v-if="hardwaresetups[selectedIdforEdit]!=undefined">
						
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.vessel[dicts.lang] }}</label>
							<!-- <input type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEdit].vessel_id" /> -->
							<smart-search init url="/api/master/seeker/vessel" key-tag="name"
							              :usedefault="hardwaresetups[selectedIdforEdit].vessel!=null"
							              :default-value="hardwaresetups[selectedIdforEdit].vessel!=null?hardwaresetups[selectedIdforEdit].vessel.name:''"
							              v-on:update="(data)=>updateKapal(data)"></smart-search>
						</div>
					
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.packet[dicts.lang] }}</label>
							<smart-select name="packet" usedefault
							              :default-value="translatePacket(hardwaresetups[selectedIdforEdit].packet)"
							              :options="packetTypeOptions"
							              v-on:update="(value)=>{hardwaresetups[selectedIdforEdit].packet=value}">
							</smart-select>
						</div>

						<!-- APPLICATION INSTALED  -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">APPLICATION INSTALED</label>
							<smart-search init url="/api/master/seeker/applications" usedefault
							              :default-value="hardwaresetups[selectedIdforEdit].application.application_name"
							              key-tag="application_name"
							              v-on:update="(data)=>smartSearchUpdateApplication(data)">
							</smart-search>
							</div>
						<!-- DEVICE STATUS -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">DEVICE STATUS</label>

							<select
							class="form-control"
							v-model="hardwaresetups[selectedIdforEdit].device_status_id"
							@change="updateForwardEdit">

							<option value="">Pilih Device Status</option>

							<option
							v-for="status in deviceStatuses"
							:key="status.id"
							:value="status.id">

							{{ status.status_code }}

							</option>

							</select>
							</div>


							<!-- STATUS REPORT -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">STATUS REPORT</label>

							<input
							type="text"
							class="form-control"
							v-model="hardwaresetups[selectedIdforEdit].forward"
							readonly>

							</div>
						<!-- STATUS REPORT -->
						<!--<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">STATUS REPORT</label>
							<smart-select 
								name="forward" 
								usedefault
								:default-value="hardwaresetups[selectedIdforEdit].forward"
								:options="forwardTypeOptions"
								v-on:update="(value) => {hardwaresetups[selectedIdforEdit].forward = value }">
							</smart-select>
						</div>-->

						<!-- SETUP DATE  -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.test_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-test-date"
							                   v-model="hardwaresetups[selectedIdforEdit].date_test"
							                   class="mb-2">{{ hardwaresetups[selectedIdforEdit].date_test }}
							</b-form-datepicker>
						</div>
						
						<!-- SKAT DATE -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.skat_date[dicts.lang] }}</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-skat"
							                   v-model="hardwaresetups[selectedIdforEdit].date_skat"
							                   class="mb-2">{{ hardwaresetups[selectedIdforEdit].date_skat }}
							</b-form-datepicker>
						</div>
						<!-- SPKP ID / IMO-->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.spkp_id[dicts.lang] }}</label>
							<input type="text" class="form-control w-100 rounded" 
								v-model="hardwaresetups[selectedIdforEdit].id_transmitter" />
							
						</div>

						<!--NOMER JB) -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.jb_number[dicts.lang] }}</label>

							<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata"
							              :usedefault="hardwaresetups[selectedIdforEdit].jb!=null"
							              :default-value="hardwaresetups[selectedIdforEdit].jb!=null?hardwaresetups[selectedIdforEdit].jb.serial_number:''"
							              :addon="{item:'jb,Junction box'}" key-tag="serial_number"
							              v-on:update="(data)=>smartSearchUpdateNoJb(data)">
							</smart-search>

						</div>
						<!--NOMER BUKU KAPAL (NBK) -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">NBK</label>
							<input type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEdit].nbk" />
							
						</div>
						<!-- NOTES -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">{{ dicts.notes[dicts.lang] }}</label>
							<textarea type="text" class="form-control w-100 rounded"
							          v-model="hardwaresetups[selectedIdforEdit].notes"/>
						</div>
						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Hardware Setup.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Hardware Setup.</p>
										</div>
										<div v-for="err in errorHardwareSetupList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button" v-on:click="updateHardwareSetup">
									{{ dicts.submit[dicts.lang] }}
								</button>
								<button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-hardware')">
									{{ dicts.close[dicts.lang] }}
								</button>
							</div>
						</div>
					</template>
				</b-modal>
				
				
					<b-modal id="modal-edit-status-hardware" title="STATUS UPDATE" scrollable no-close-on-backdrop size="lg">
						<div class="row" v-if="hardwaresetups[selectedIdforEditStatus]!=undefined">
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">HARDWARE STATUS</label>
								<smart-select 
									name="status" 
									:options="statusTypeOptions" 
									usedefault
									:default-value="hardwaresetups[selectedIdforEditStatus].status"
									v-on:update="updateStatusField">
								</smart-select>

							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="updateSavedStatus">
									<div class="alert alert-success" role="alert">
										Berhasil Update Data Hardware Setup.
									</div>
								</div>
							</div>

							<!-- Appears if status = replacement -->
							<div class="col-12 w-100 my-3"
								v-if="hardwaresetups[selectedIdforEditStatus].status=='replacement'">
								
								<!-- field new client -->
								<div class="w-100">
									<div class="row mt-3">
										<div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">{{ dicts.no_sn[dicts.lang] }}</label>
											<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
														:usedefault="hardwaresetups[selectedIdforEditStatus].serial_number!=null"
														:default-value="hardwaresetups[selectedIdforEditStatus].serial_number!=null?hardwaresetups[selectedIdforEditStatus].serial_number.serial_number:''"
														:addon="{item:'antena,Transmitter'}" key-tag="serial_number"
														v-on:clear="(res)=>{clearHQCDataStatus()}"
														v-on:update="(data)=>smartSearchEditSerialNumber(data)"></smart-search>
										</div>
										<div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">ID Transmitter</label>
											<input type="text" class="form-control w-100 rounded"
												v-model="hardwaresetups[selectedIdforEditStatus].id_transmitter"/>
										</div>
										<div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">{{ dicts.no_jb[dicts.lang] }}</label>
											<smart-search init url="/api/inventaris/seeker/hardware-qc-metadata?ready=yes"
														:usedefault="hardwaresetups[selectedIdforEditStatus].jb!=null"
														:default-value="hardwaresetups[selectedIdforEditStatus].jb!=null?hardwaresetups[selectedIdforEditStatus].jb.serial_number:''"
														:addon="{item:'jb,Junction box'}" key-tag="serial_number"
														v-on:update="(data)=>smartSearchEditNoJb(data)">
											</smart-search>
										</div>
										
										<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">Tanggal</label>
											<b-form-datepicker :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}" id="datepicker-due-date" v-model="hardwaresetups[selectedIdforEdit].date_at" class="mb-2">{{hardwaresetups[selectedIdforEdit].date_at}}</b-form-datepicker>
										</div>
										<div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">INFORMATION</label>
											<textarea type="text"  class="form-control w-100 rounded" v-model="hardwaresetups[selectedIdforEditStatus].notes" />
										</div> -->
									</div>
								</div>
							</div>

							<div class="col-12 w-100 my-3">
								<div class="w-100">
									<div class="row mt-3">
										<div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">{{ dicts.date[dicts.lang] }}</label>
											<b-form-datepicker today-button reset-button close-button
												:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
												id="datepicker-due-date"
												v-model="hardwaresetups[selectedIdforEditStatus].date_at" class="mb-2">
												{{ hardwaresetups[selectedIdforEditStatus].date_at }}
											</b-form-datepicker>
										</div>
										<div class="col-12 col-md-6 col-lg-4 mt-2">
											<label class="d-block">{{ dicts.notes[dicts.lang] }}</label>
											<textarea type="text" class="form-control w-100 rounded"
													v-model="hardwaresetups[selectedIdforEditStatus].notes"/>
										</div>
									</div>
								</div>
							</div>

						</div>
						<template #modal-footer>
							<div class="w-100 text-right m-0 p-0">
								<hr>
								<div class="col-12 mt-3">
									<div class="w-100 align-items-center justify-content-start" v-if="errorUpdateStatus">
										<div class="alert alert-danger" role="alert">
											<div class="my-0">
												<p class="d-block mt-1 text-left">Gagal update Hardware Setup.</p>
											</div>
											<div v-for="err in errorHardwareSetupList" v-bind:key="err" class="my-0">
												<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
											</div>
										</div>
									</div>
								</div>
								<div class="col-12 mt-3">
									<div class="d-flex align-items-center justify-content-start" v-if="updatingStatus">
										<div class="spinner-border" role="status" aria-hidden="true"></div>
										<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
									</div>
									<button class="btn btn-info float-right" type="button"
											v-on:click="updateStatusHardwareSetup">
										{{ dicts.submit[dicts.lang] }}
									</button>
									<b-button class="btn btn-secondary mr-2"
											@click="$bvModal.hide('modal-edit-status-hardware')">
										{{ dicts.close[dicts.lang] }}
									</b-button>
								</div>
							</div>
						</template>
					</b-modal>

				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-hardware" title="Detail data" scrollable
				         no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&hardwaresetups.length>0">
						<b-row class="pt-1" v-if="hardwaresetups[selectedDetail]!=undefined">
							<b-col cols="12">
								<table rules="rows" class="table w-100">
									<tbody>
									<tr>
										<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt"
										    colspan="2" scope="row">Detail
											Hardware Setup
										</th>
									</tr>
									<tr>
										<th scope="row">{{ dicts.no_sn[dicts.lang] }}</th>
										<td>
											{{
												hardwaresetups[selectedDetail].serial_number != null ? hardwaresetups[selectedDetail].serial_number.serial_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">ID Transmitter</th>
										<td>
											{{
												hardwaresetups[selectedDetail].id_transmitter != null ? hardwaresetups[selectedDetail].id_transmitter : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.no_jb[dicts.lang] }}</th>
										<td>
											{{
												hardwaresetups[selectedDetail].jb != null ? hardwaresetups[selectedDetail].jb.serial_number : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.vessel[dicts.lang] }}</th>
										<td>
											{{
												hardwaresetups[selectedDetail].vessel != null ? hardwaresetups[selectedDetail].vessel.name : "-"
											}}
										</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.packet[dicts.lang] }}</th>
										<td>{{ translatePacket(hardwaresetups[selectedDetail].packet) }}</td>
									</tr>
									<tr>
										<th scope="row">Paket Install</th>
										<td>{{ hardwaresetups[selectedDetail].application.application_name }}</td>
									</tr>
									<tr>
										<th scope="row">Forward</th>
										<td>{{ translateForward(hardwaresetups[selectedDetail].forward) }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.test_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_test | timeformat }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.activate_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_active | timeformat }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.due_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_due | timeformat }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.skat_date[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].date_skat | timeformat }}</td>
									</tr>
									<tr>
										<th scope="row">{{ dicts.notes[dicts.lang] }}</th>
										<td>{{ hardwaresetups[selectedDetail].notes }}</td>
									</tr>

									</tbody>

								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-hardware'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc content-class="m-0" id="modal-detail-histories-hardware" size="lg"
				         title="HISTORY" scrollable no-close-on-backdrop @hide="historydetailModalClose">
					
					<b-container fluid v-if="!loadData&&hardwaresetups.length>0">
						<b-row class="pt-1" v-if="hardwaresetups[selectedHistories]!=undefined">
							<b-col cols="12">
								<table class="table w-100 table-bordered">
									<tbody>
									<tr class="table-header-blue">
										<th scope="row">{{ dicts.date[dicts.lang] }}</th>
										<th scope="row">{{ dicts.no_sn[dicts.lang] }}</th>
										<th scope="row">SPKP ID / IMO</th>
										<th scope="row">{{ dicts.no_jb[dicts.lang] }}</th>
										<th scope="row">STATUS</th>
										<th scope="row">{{ dicts.notes[dicts.lang] }}</th>
									</tr>

									<tr v-for="history in hardwaresetups[selectedHistories].histories"
            							v-bind:key="'history'+history.id">
										<td>
											<b>{{ history.date_at != null ? history.date_at : "-" | timeformat }}</b>
										</td>
										<td> {{ history.old_serial_number != null ? history.old_serial_number.serial_number : "-" }}</td>
										<td>{{ history.old_id_transmitter != null ? history.old_id_transmitter : "-" }}</td>
										<td> {{ history.old_jb != null ? history.old_jb.serial_number : "-" }}</td>
										<td>{{ history.old_status }}</td>
										<td>{{ history.notes != null ? history.notes : "-" }}</td>
									</tr>
									</tbody>

								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-histories-hardware'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/inventaris/hardware-setup/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					{{ dicts.desc_delete[dicts.lang] }}:<br>
					<ul>
						<li>{{ dicts.no_sn[dicts.lang] }}: {{ itemToDelete.id_transmitter }}</li>
					</ul>
				</modal-delete>

			</div>
		</div>
	</div>
</template>
<script>
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import CreateVessel from "../../components/CreateVessel";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"create-vessel": CreateVessel,
		"modal-delete": ModalDelete
		
	},
	name: "HardwareSetupForm",
	data() {
		return {
			currentPage: 1,
			rowLimit: 10,
			totalItems: 0,
			listvessellabel: "",
			newsetupapplabel: "",
			newsetupjblabel: "",
			newsetupsnlabel: "",
			nextUrl: null,
			prevUrl: null,
			perPage: null,
			isMobile: false,
			itemToDelete: {},
			deleteId: 0,
			role: "",
			selectedVesselName: "",
			selectedVesselId: 0,
			hardwaresetups: [],
			searchQuery: '',
			allHardwaresetups: [],
			searchValue: "",
			loadData: true,
			savingNewHardwareSetup: false,
			updating: false,
			updatingStatus: false,
			updateSaved: false,
			updateSavedStatus: false,
			deleted: false,
			deleteFail: false,
			deleteState: false,
			selectedToDelete: 0,
			errorNewHardwareSetup: false,
			errorUpdate: false,
			errorUpdateStatus: false,
			errorHardwareSetupList: [],
			newHardwareSetupSaved: false,
			selectedIdforVessel: 0,
			selectedIdforEdit: 0,
			selectedIdforEditStatus: 0,
			selectedTab: 0,
			selectedTabStatus: 0,
			selectedDetail: 0,
			selectedHistories: 0,
			statusInterval: [],
			form: {
				device_status: '',
				device_status_id: '',
				forward: ''
			},
			deviceStatuses: [],
			
			newHardwareSetup: {
				serial_number_id: "",
				jb_id: "",
				vesselExisting: "existing",
				vessel_id: "",
				id_transmitter: "",
				nbk: "",
				status: "new",
				aplication:'VMS',
				application_id: "",
				forward: "",	
				date_test: new Date().toISOString().substr(0, 10),
				date_active: new Date().toISOString().substr(0, 10),
				date_skat: "",
				date_due: "",
				notes: "",
				jbNumber: "",
				interval_status: "",
			},
			formHardwareSetupActive: false,
			hardwaresetupTableStructure: [
				//label: nama heading, key: nama object property
				{label: "NO", key: null},
				{
					label: {
						id: "SERIAL NUMBER",
						en: "SERIAL NUMBER"
					},
					key: "serial_number"
				},
				{
					label: {
						id:"SPKP ID / IMO",
						en:"SPKP ID / IMO"
					},
					key: "id_transmitter"},
				{
					label: {
						id: "NO JB",
						en: "JB NUMBER"
					},
					key: "serial_number"
				},
				{
					label: {
						id: "NBK",
						en: "NBK"
					},
					key: "nbk"
				},
				{
					label: {
						id: "VASSEL NAME",
						en: "VASSEL NAME"
					},
					key: "vessel"
				},
				{
					label: {
						id: "NAMA CUSTOMER",
						en: "CUSTOMER NAME"
					},
					key: "client_name"
				},
				{
					label: {
						id: "APPLICATION INSTALED",
						en: "APPLICATION INSTALED"
					},
					key: null
				},
				{
					label: {
						id: "DEVICE STATUS",
						en: "DEVICE STATUS"
					},
					key: null
				},
				{
					label: {
						id: "STATUS REPORT",
						en: "STATUS REPORT"
					},
					key: null
				},
				{
					label: {
						id: "GT",
						en: "GT"
					},
					key: null
				},
				{
					label: {
						id: "STATUS TRANSMITER",
						en: "STATUS TRANSMITER"
					},
					key: null
				},
				{
					label: {
						id: "SETUP DATE",
						en: "SETUP DATE"
					},
					key: null
				},
				{
					label: {
						id: "START OF AIRTIME ",
						en: "START OF AIRTIME "
					},
					key: null
				},
				{
					label: {
						id: "END OF AIRTIME ",
						en: "END OF AIRTIME "
					},
					key: null
				},
				
				{
					label: {
						id: "ACTION",
						en: "ACTION"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				add_form: {
					id: "ADD NEW",
					en: "ADD NEW"
				},
				tittle_form: {
					id: "HADWARE SETUP",
					en: "HARDWARE SETUP"
				},
				no_sn: {
					id: "SERIAL NUMBER",
					en: "SERIAL NUMBER"
				},
				spkp_id: {
					id: "SPKP ID / IMO",
					en: "SPKP ID / IMO"
				},
				no_jb: {
					id: "NOMER JB",
					en: "JB NUMBER"
				},
				customer_name: {
					id: "CUSTOMER NAME",
					en: "CUSTOMER NAME"
				},
				vessel: {
					id: "VASSEL NAME",
					en: "VASSEL NAME"
				},
				jb_number: {
					id: "NOMER JB",
					en: "JB NUMBER"
				},
				packet: {
					id: "ACCOUNT PACKET DATA",
					en: "ACCOUNT PACKET DATA"
				},
				test_date: {
					id: "SETUP DATE",
					en: "SETUP DATE"
				},
				activate_date: {
					id: "AIRTIME MULAI",
					en: "AIRTIME STARTS"
				},
				skat_date: {
					id: "SKAT DATE",
					en: "SKAT DATE"
				},
				due_date: {
					id: "AIRTIME SELESAI",
					en: "AIRTIME ENDED"
				},
				notes: {
					id: "INFORMATION",
					en: "INFORMATION"
				},
				submit: {
					id: "SAVE",
					en: "SAVE"
				},
				new_vessel: {
					id: "KAPAL BARU",
					en: "NEW SHIP"
				},
				list_vessel: {
					id: "DAFTAR KAPAL",
					en: "List of ships"
				},
				close: {
					id: "TUTUP",
					en: "CLOSE"
				},
				date: {
					id: "UPDATE DATE",
					en: "UPDATE DATE"
				},
				desc_delete: {
					id: "Yakin mau menghapus data dengan detail berikut",
					en: "You are sure you want to delete data with the following details"
				}
			},
			packetTypeOptions: [
				{label: "Not Active", value: "not_active"},
				{label: "MSP Plan Test", value: "test_idp690"},
				{label: "IDP690 10K-128:01", value: "activation_idp690_10k_01"},
				{label: "IDP690 10K-128:02", value: "activation_idp690_10k_02"},
				{label: "IDP690 10K-128:03", value: "activation_idp690_10k_03"},
				{label: "ST6100 10K-128:01", value: "activation_st6100_10k"},
				{label: "ST6100 10K-128:02", value: "activation_100k"},
				{label: "IDPST 10K-129:03", value: "activation_100k"},
				{label: "GOST6100 10K-128:01", value: "activation_100k"},
				{label: "SC1000 24H:01", value: "sc1000_ogx"},
				{label: "SC1000-OGWS 24H:01", value: "sc1000_ogws"},
				{label: "PRF-IES-INT-24xd", value: "activation_100k"},
				{label: "ST6100 10K-128:04", value: "sc1000"},
				{label: "Blocked", value: "blocked"},
			],
			statusTypeOptions: [
				{label: "New", value: "new"},
				{label: "Repair", value: "repair"},
				{label: "Replacement", value: "replacement"}
			],
			
			forwardTypeOptions: [
				{label: "No Forwarded", value: "No Forwarded"},
				{label: "PSDKP", value: "PSDKP"},
				{label: "SDI", value: "SDI"},
				{label: "PSDKP & SDI", value: "PSDKP & SDI"},
				{label: "PSDKP Blocked", value: "PSDKP Blocked"},
				{label: "SDI Blocked", value: "SDI Blocked"},
				{label: "PSDKP & SDI Blocked", value: "PSDKP & SDI Blocked"},
				{label: "Non Goverment", value: "Non Goverment"}
			]
			

		};
	},
	created() {
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getHardwareSetups();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing Hardware setup lang");
			this.dicts.lang = localStorage.getItem("lang");
		});

		// --- TAMBAHKAN BARIS INI ---
		const savedRole = localStorage.getItem("role");
		this.role = savedRole ? savedRole.toLowerCase().trim() : "";
		// ---------------------------
		const intervals = [];
		for (let i = 20; i <= 1440; i += 10) { 
		intervals.push({
			value: i,
			label: `${i} menit`
		});
		}
		this.statusInterval = intervals;
		
	},
	computed: {
		filteredHardwareSetups() {
			const term = this.searchQuery.toLowerCase(); 
			return this.hardwaresetups.filter((obj) => {
			const serialMatch = obj.serial_number ? obj.serial_number.serial_number.toLowerCase().includes(term) : false;
			const transmitterMatch = obj.id_transmitter ? obj.id_transmitter.toLowerCase().includes(term) : false;
			const jbMatch = obj.jb ? obj.jb.serial_number.toLowerCase().includes(term) : false;
			const vesselMatch = obj.vessel ? obj.vessel.name.toLowerCase().includes(term) : false;
			const clientMatch = obj.vessel && obj.vessel.client ? obj.vessel.client.first_name.toLowerCase().includes(term) : false;

			// Return true if any of the fields match
			return serialMatch || transmitterMatch || jbMatch || vesselMatch || clientMatch;
			});
		},
		
	},
	methods: {
		translatePacket(role) {
			var label = "";
			switch (role) {
				case "not_active":
					label = "Not Active";
					break;
				case "test_idp690":
					label = "MSP Plan Test";
					break;
				case "activation_idp690_10k_01":
					label = "IDP690 10K-128:01";
					break;
				case "activation_idp690_10k_02":
					label = "IDP690 10K-128:02";
					break;
				case "activation_idp690_10k_03":
					label = "IDP690 10K-128:03";
					break;
				case "activation_st6100_10k":
					label = "Activation ST6100 10k";
					break;
				case "activation_100k":
					label = "Activation 1001";
					break;
				case "sc1000_ogx":
					label = "SC1000 24H:01";
					break;
				case "sc1000_ogws":
					label = "SC1000-OGWS 24H:01";
					break;
				case "blocked":
					label = "Blocked";
					break;
			}
			return label;
		},
		translateForward(role) {
			var label = "";
			switch (role) {
				case "No Forwarded":
					label = "No Forwarded";
					break;
				case "PSDKP":
					label = "PSDKP";
					break;
				case "SDI":
					label = "SDI";
					break;
				case "PSDKP & SDI":
					label = "PSDKP & SDI";
					break;
				case "Non Goverment":
					label = "Non Goverment";
					break;
			}
			return label;
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getHardwareSetups();
			}
		},
		clearHQCData() {
			this.newHardwareSetup.serial_number_id;
		},
		clearHQCDataStatus() {
			this.hardwaresetups[selectedIdforEditStatus].serial_number_id;
		},
		createVesselResult(data) {
			if (data.status) {
				console.log(this.selectedVesselId = data.data.id);
				this.selectedVesselName = data.data.name;
				this.selectedVesselId = data.data.id;
				this.newHardwareSetup.vessel_id = data.data.id;
				this.saveNewvessel = data.data.name;
				this.$bvModal.hide("modal-create-vessel");
			}
		},
		
		changePage(isNext) {
			let url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url).searchParams);
			const myParams = params.get("page");
			const newUrl = this.$baseUrl + "/api/inventaris/hardware-setup?limit=" + this.rowLimit + "&page=" + myParams;

			this.currentPage = myParams;
			this.getHardwareSetups(newUrl);
		},
		
		
		handleSearch() {
				if (this.searchQuery) {
					this.filteredHardwaresetups = []; // Reset hasil pencarian
					this.currentPage = 1; 
					this.hasMoreData = true; 
					this.loadSearchResults();
				} else {
					this.filteredHardwaresetups = this.hardwaresetups;
				}
			},

		loadSearchResults() {
				if (!this.hasMoreData || this.isLoading) return;

				this.isLoading = true;
				const searchParam = this.searchQuery ? `search=${encodeURIComponent(this.searchQuery)}` : '';
				const pageParam = `page=${this.currentPage}`;
				const limitParam = 'limit=50'; 

				const queryParams = `${searchParam}&${pageParam}&${limitParam}`;

				axios.get(`${this.$baseUrl}/api/inventaris/hardware-setup?${queryParams}`, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("accessToken")}`
					}
				}).then((result) => {
					const newData = result.data.data;
					if (newData.length > 0) {
						this.filteredHardwaresetups = [...this.filteredHardwaresetups, ...newData];
						this.currentPage++;
					} else {
						this.hasMoreData = false; 
					}
					this.isLoading = false;
				}).catch((err) => {
					console.error(err);
					this.isLoading = false;
				});
		},
		
		doSearch() {
			this.getHardwareSetups(null, this.searchTerm);
		},
		getHardwareSetups(url = null, search = '') {
			this.loadData = true;

			let finalUrl = url;
			if (!finalUrl) {
				finalUrl = this.$baseUrl + "/api/inventaris/hardware-setup?limit=" + this.rowLimit;
				if (search) {
				finalUrl += `&search=${encodeURIComponent(search)}`;
				}
			}

			axios.get(finalUrl, {
				headers: {
				Authorization: "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log("✅ Setup results:", result);

				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.totalItems = result.data.total;

				this.hardwaresetups = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				if (err.response && err.response.status === 401) {
				localStorage.removeItem("accessToken");
				this.$router.push("/login");
				}
				console.error(" Error loading data:", err);
				this.loadData = false;
			});
		},
		
		
		updateHardwareSetup() {
			this.updating = true;
			this.errorUpdate = false;

			let data = this.hardwaresetups[this.selectedIdforEdit];

			axios.put(
				this.$baseUrl + "/api/inventaris/hardware-setup/update/" + data.id,
				data,
				{
					headers: { 
						"Authorization": "Bearer " + localStorage.getItem("accessToken")
					}
				}
			).then((result) => {
				this.updating = false;

				if (result.status === 200) {
					this.updateSaved = true;
					this.getHardwareSetups();
					setTimeout(() => {
						this.$bvModal.hide("modal-edit-hardware");
						this.updateSaved = false;
					}, 1000);
				}

			}).catch((err) => {

				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}

				this.updating = false;
				this.errorUpdate = true;
				this.errorHardwareSetupList = err.response.data.errors || {};
				console.log(err.response);
			});
		},

		updateStatusHardwareSetup() {
			this.updatingStatus = true;
			this.errorUpdateStatus = false;
			
			console.log(this.hardwaresetups[this.selectedIdforEditStatus]);

			
			if (!this.hardwaresetups[this.selectedIdforEditStatus].date_at) {
				this.updatingStatus = false;
				this.errorUpdateStatus = true;
				this.errorHardwareSetupList = [["Date is required"]];
				return;
			}

			
			if (!this.hardwaresetups[this.selectedIdforEditStatus].notes || this.hardwaresetups[this.selectedIdforEditStatus].notes.trim() === "") {
				this.updatingStatus = false;
				this.errorUpdateStatus = true;
				this.errorHardwareSetupList = [["Notes must be filled in"]];
				return;
			}
			axios.put(
				this.$baseUrl + "/api/inventaris/hardware-setup/" + this.hardwaresetups[this.selectedIdforEditStatus].id,
				{
					
					status: this.hardwaresetups[this.selectedIdforEditStatus].status,
					date_at: this.hardwaresetups[this.selectedIdforEditStatus].date_at,
					notes: this.hardwaresetups[this.selectedIdforEditStatus].notes || "-",
					serial_number_id: this.hardwaresetups[this.selectedIdforEditStatus].serial_number_id,
					jb_id: this.hardwaresetups[this.selectedIdforEditStatus].jb_id,
					id_transmitter: this.hardwaresetups[this.selectedIdforEditStatus].id_transmitter
				},
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status === 200) {
					this.updatingStatus = false;
					this.updateSavedStatus = true;
					this.getHardwareSetups();

					setTimeout(() => {
						this.$bvModal.hide("modal-edit-status-hardware");
						this.updateSavedStatus = false;
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updatingStatus = false;
				this.errorUpdateStatus = true;
				console.log(err.response);
			});
		},
		updateStatusField(value) {
				if (this.selectedIdforEditStatus !== null) {
					this.hardwaresetups[this.selectedIdforEditStatus].status = value;
				}
		},

		smartSearchUpdatedVessel(data, index) {
			this.newHardwareSetup.vessel_id = data.id;
			this.selectedVesselId = data.id;
			this.selectedVesselName = data.name;
			// UNTUK MENGHAPUS MODAL
			this.$bvModal.hide("modal-create-vessel");
			//console.log(this.newHardwareSetup.vessel_id[index])
		},
		updateKapal(data) {
			this.hardwaresetups[this.selectedIdforEdit].vessel_id = data.id;
		},
		updateNewHsPacket(data) {
			this.newHardwareSetup.packet = data;
		},
		updateNewHsStatus(data) {
			this.newHardwareSetup.status = data;
		},
		updateNewHsAplication(data) {
			this.newHardwareSetup.aplication = data;
		},
		updateNewHsForward(data) {
			this.newHardwareSetup.forward = data;
		},
		smartSearchAddSerialNumber(data) {
			console.log("serial number selected");
			console.log(data);
			this.newHardwareSetup.serial_number_id = data.id;
		},
		smartSearchAddNoJb(data) {
			this.newHardwareSetup.jb_id = data.id;
		},
		
		smartSearchUpdateNoJb(data) {
			// Make sure the data contains id and serial_number
			console.log('Selected JB:', data);

			// Save JB ID and JB object to hardwaresetup
			this.hardwaresetups[this.selectedIdforEdit].jb_id = data.id;
			this.hardwaresetups[this.selectedIdforEdit].jb = {
			serial_number: data.serial_number
			};
		},
		smartSearchEditSerialNumber(data) {
			console.log("serial number selected");
			console.log(data);
			this.hardwaresetups[this.selectedIdforEditStatus].serial_number_id = data.id;
		},
		smartSearchEditNoJb(data) {
			// this.hardwaresetups[selectedIdforEditStatus].jb_id = data.id;
			console.log('Selected JB:', data);

			// Save JB ID and JB object to hardwaresetup
			this.hardwaresetups[this.selectedIdforEdit].jb_id = data.id;
			this.hardwaresetups[this.selectedIdforEdit].jb = {
			serial_number: data.serial_number
			};
			
		},
		smartSearchAddApplication(data) {
			this.newHardwareSetup.application_id = data.id;
		},
		smartSearchAddPacket(data) {
			this.newHardwareSetup.packet = data.id;
		},
		smartSearchUpdateApplication(data) {
			this.hardwaresetups[this.selectedIdforEditStatus].application_id = data.id;
		},
		AddNewVesselStatus(data) {
			this.newvessel.status = data;
		},
		
		deleteItem(index) {
			console.log("button delete untuk user id: " + index);
		},
		

		saveNewHardwareSetup() {
			
			this.savingNewHardwareSetup = true;
			this.errorNewHardwareSetup = false;
			
			axios.post(this.$baseUrl + "/api/inventaris/hardware-setup", this.newHardwareSetup,
				
				{
					"headers":
						{"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				console.log(result);
				this.savingNewHardwareSetup = false;
				this.newHardwareSetupSaved = true;
				this.resetForm();
				this.getHardwareSetups();
				setTimeout(() => {
					this.formHardwareSetupActive = false;
					this.newHardwareSetupSaved = false;
				}, 1000);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.clear();
				console.log(err.response);
				this.errorHardwareSetupList = [];
				this.errorHardwareSetupList = Object.values(err.response.data.errors);
				console.log(this.errorHardwareSetupList);
				this.savingNewHardwareSetup = false;
				this.errorNewHardwareSetup = true;
			});
			
		},
		resetForm() {
			this.newHardwareSetup.serial_number_id = "";
			this.newHardwareSetup.jb_id = "";
			this.newHardwareSetup.vesselExisting = "existing";
			this.newHardwareSetup.vessel_id = "";
			this.newHardwareSetup.id_transmitter = "";
			this.newHardwareSetup.status = "new";
			this.newHardwareSetup.packet = "test_idp690";
			// aplication='VMS';
			this.newHardwareSetup.application_id = "";
			this.newHardwareSetup.forward = "tidakada";
			this.newHardwareSetup.date_test = "";
			this.newHardwareSetup.date_active = "";
			this.newHardwareSetup.date_skat = "";
			this.newHardwareSetup.date_due = "";
		},
		deleteData() {
			this.deleteState = true;
			axios.delete(
				this.$baseUrl + "/api/inventaris/hardware-setup/" + this.hardwaresetups[this.selectedToDelete].id,
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			)
				.then((result) => {
					if (result.status == 200) {
						this.hardwaresetups.splice(this.selectedToDelete, 1);
						this.deleted = true;
						setTimeout(() => {
							this.deleted = false;
						}, 1500);

					} else {
						this.deleteFail = true;
					}
					this.deleteState = false;
				}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.deleteState = false;
				this.deleteFail = true;
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-po");
			}
		},
		detailModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-hardware");
			}
		},
		historydetailModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-histories-hardware");
			}
		},
		formatTanggal(value) {
			if (!value) return '-';
			const options = { day: '2-digit', month: 'long', year: 'numeric' };
			return new Date(value).toLocaleDateString('id-ID', options);
		},
		updateNewIntervalStatus(val) {
			console.log("Interval terpilih:", val);
		},
		fetchDeviceStatuses() {
			const url = this.$baseUrl + '/api/device-status'; // base URL + endpoint
			const token = localStorage.getItem('accessToken');

			axios.get(url, {
				headers: {
				'Authorization': 'Bearer ' + token
				}
			})
			.then(response => {
				console.log("Data deviceStatuses:", response.data);
				this.deviceStatuses = response.data;
			})
			.catch(error => {
				console.error("Error load device status (axios):", error);
			});
		},
		updateForwardEdit(){

		if(this.selectedIdforEdit == null) return

		let item = this.hardwaresetups[this.selectedIdforEdit]

		if(!item) return

		const status = this.deviceStatuses.find(
		s => s.id == item.device_status_id
		)

		let forwardValue = ''

		if(status){

		switch(status.status_code){

		case 'ACTIVE':
		forwardValue = 'PSDKP'
		break

		case 'ACTIVE NG':
		forwardValue = 'Non Goverment'
		break
		
		case 'NOT-ACTIVE':
		case 'DE-ACTIVE':
		case 'MAINTENANCE':
		case 'BROKEN':
		case 'STANDBY':
		case 'SUSPENSIONS':
		case 'EXPIRED':
		case 'DOCKING':
		forwardValue = 'No Forwarded'
		break

		default:
		forwardValue = ''

		}

		}

		this.hardwaresetups[this.selectedIdforEdit].forward = forwardValue

		},
		


	},
	mounted() {
		this.getHardwareSetups(); 
		this.fetchDeviceStatuses();

		
    	
	},
	watch: {
  
    'form.device_status_id'(newId) {

	
	  this.newHardwareSetup.device_status_id = newId;

      if (!newId) {
        this.form.forward = '';
		this.newHardwareSetup.forward = '';
        return;
      }

     // search for status objects based on id
      const selectedStatus = this.deviceStatuses.find(s => s.id === newId);
      let forwardValue = '';

      if (selectedStatus) {
        switch (selectedStatus.status_code) {
          case 'ACTIVE':
            forwardValue = 'PSDKP';
            break;
          case 'NOT-ACTIVE':
            forwardValue = 'No Forwarded';
            break;
		  case 'ACTIVE NG':
            forwardValue = 'Non Goverment';
            break;
		  case 'DE-ACTIVE':
            forwardValue = 'No Forwarded';
            break;
          case 'MAINTENANCE':
            forwardValue = 'No Forwarded';
            break;
          case 'BROKEN':
            forwardValue = 'No Forwarded';
            break;
          case 'STANDBY':
            forwardValue = 'No Forwarded';
            break;
		  case 'SUSPENSIONS':
            forwardValue = 'No Forwarded';
            break;
		  case 'EXPIRED':
            forwardValue = 'No Forwarded';
            break;
		  case 'DOCKING':
            forwardValue = 'No Forwarded';
            break;
          default:
            forwardValue = '';
        }
      }

      // set STATUS REPORT
      this.form.forward = forwardValue;

     // call old function to sync
      if (typeof this.updateNewHsForward === 'function') {
        this.updateNewHsForward(forwardValue);
      }
    }
  }
};
</script>
<style scoped>
.mobile-scroll-wrapper{
	width:100%;
	overflow-x:auto;
	overflow-y:hidden;
	-webkit-overflow-scrolling:touch;
}

.mobile-scroll-content{
	min-width:1400px;
}

/* MOBILE */
@media(max-width:768px){

	.mobile-scroll-wrapper{
		display:block;
		width:100%;
	}

	.mobile-scroll-content{
		min-width:1400px;
	}

	.pagination-mobile{
		flex-direction:column;
		align-items:flex-start !important;
		gap:10px;
	}

}
.dropdown-menu {
	display: none;
}

.btn {
	padding: 2px 6px;
}

/* ::v-deep .modal-content {
    margin: -5.00rem auto;
} */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 15%;
}

::v-deep .modal.show .modal-dialog {
	transform: translate(0px, 10%);
}

::v-deep .modal-dialog-scrollable .modal-content {
	max-height: calc(100vh - 3.5rem);
}

::v-deep .modal.show .modal-dialog {
	transform: none;
	-webkit-transform: none;
}
 
/* DESKTOP */
.search-container {
	position: relative; 
	width: 100%; 
	margin-top: 0px; 
	padding-left: 0;
	margin-left: 0%; 
}

.search-input {
	position: absolute;
	right: 0;
	top: 20px;

	padding: 10px;

	border: 1px solid #ccc;
	border-radius: 5px;

	font-size: 16px;

	width: 20%;
	min-width: 220px;

	box-sizing: border-box;
}


/* TABLET */
@media (max-width: 992px){

	.search-input{
		width: 35%;
		min-width: unset;
	}

}


/* MOBILE */
@media (max-width: 768px){

	.search-container{
		position: relative;
		width: 100%;
		min-height: auto;
		margin-bottom: 10px;
	}

	.search-input{

		position: relative;

		left: 0;
		right: 0;
		top: 0;

		width: 100%;

		font-size: 16px;

	}

}
/* Blue header with white text */
.table-header-blue th {
    background-color: #1B2060;
    color: white;
    border: 1px solid #ccc; 
}

/* Table data cells with gray lines */
.table-bordered td {
    border: 1px solid #ccc;
}

/* Supaya tabel tidak mepet */
.table {
    border-collapse: collapse;
}
/* color device */
.text-green {
	color: green;
}
</style>
